export default __webpack_public_path__ + "static/media/creativity.45a2127b.svg";